import React from 'react'
import PropTypes from 'prop-types'
import StackedCards from './StackedCards'
import { useViewer } from '~/components/ViewerContext'
import { Button } from '@ticketswap/solar'
import { track } from '~/utils'
import { AUTHENTICATION_VIEWED } from '~/lib/tracking-events'
import AuthDialog from '~/components/AuthDialog'
import ConnectFacebookCard from './ConnectFacebookCard'
import EventListCard from './EventListCard'

const FacebookEvents = ({ t }) => {
  const { viewer } = useViewer()

  if (!viewer) {
    return (
      <StackedCards
        t={t}
        title={t('home:facebookEvents.loggedOut.title')}
        text={t('home:facebookEvents.loggedOut.text')}
        button={
          <AuthDialog
            onToggle={on => {
              on && track(AUTHENTICATION_VIEWED, { trigger: 'FACEBOOK_EVENTS' })
            }}
          >
            {({ show: showAuthDialog }) => (
              <Button size="small" onClick={showAuthDialog}>
                {t('home:facebookEvents.loggedOut.button')}
              </Button>
            )}
          </AuthDialog>
        }
      />
    )
  }

  const { facebookUserPermissions = [] } = viewer
  const userEventsPermission = facebookUserPermissions.find(el => el.handle === 'user_events')
  const permissionGranted = userEventsPermission ? userEventsPermission.granted : false

  if (!permissionGranted) {
    return <ConnectFacebookCard t={t} />
  }

  return <EventListCard t={t} />
}

FacebookEvents.propTypes = {
  t: PropTypes.func.isRequired,
}

export default FacebookEvents
